import React, { useState } from 'react'
import { paginationSx, centerSx } from './SharedUsersPaginatedList'
import { List, ListSubheader, ListItemSecondaryAction, Box, Chip } from '@mui/material'
import { ListItemLocation } from './ListItemLocation'
import { useGuests } from '../hooks/useGuests'
import { LoadingMessage } from './LoadingMessage'
import { Pagination } from '@mui/lab'
import { Gutters } from './Gutters'
import { alphaSort } from '../helpers/utilHelper'
import { Avatar } from './Avatar'
import { Icon } from './Icon'

export const OrganizationGuestList: React.FC = () => {
  const [page, setPage] = useState<number>(1)
  const { guests, guestsLoaded } = useGuests()
  const perPage = 20
  const pageCount = Math.ceil(guests.length / perPage)
  const start = (page - 1) * perPage
  const pageGuests = [...guests].sort((a, b) => alphaSort(a.email, b.email)).slice(start, start + perPage)

  if (!guestsLoaded) return <LoadingMessage />

  return (
    <>
      <List>
        <ListSubheader>
          Guest
          <ListItemSecondaryAction>Shares</ListItemSecondaryAction>
        </ListSubheader>
        {pageGuests.map(guest => (
          <ListItemLocation
            dense
            key={guest.id}
            title={guest.email}
            to={`/organization/guests/${guest.id}`}
            icon={<Avatar email={guest.email} size={26} />}
          >
            <ListItemSecondaryAction>
              {!!guest.networkIds.length && (
                <Chip
                  size="small"
                  label={
                    <Box display="flex">
                      <Icon name="chart-network" size="sm" color="grayDarker" inlineLeft />
                      {guest.networkIds.length}
                    </Box>
                  }
                />
              )}
              {!!guest.deviceIds.length && (
                <Chip
                  size="small"
                  label={
                    <Box display="flex">
                      <Icon name="router" size="base" color="grayDarker" inlineLeft />
                      {guest.deviceIds.length}
                    </Box>
                  }
                />
              )}
            </ListItemSecondaryAction>
          </ListItemLocation>
        ))}
      </List>
      {guests.length > perPage && (
        <Gutters sx={centerSx}>
          <Pagination sx={paginationSx} count={pageCount} onChange={(_e, page) => setPage(page)} size="small" />
        </Gutters>
      )}
    </>
  )
}

